import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React, { Suspense } from 'react';
import { Placeholder } from 'semantic-ui-react';
import { generateGoogleSearchQuery } from '../../modules/foundation/services/google-maps';
import { AddressPropType } from '../../modules/foundation/types/address';
import { isServerSideRendering } from '../../utils/gatsby';
var LazyEmbed = /*#__PURE__*/React.lazy(function () {
  return import('semantic-ui-react/dist/commonjs/modules/Embed');
});
var Map = /*#__PURE__*/function (_React$Component) {
  _inherits(Map, _React$Component);
  var _super = _createSuper(Map);
  function Map() {
    _classCallCheck(this, Map);
    return _super.apply(this, arguments);
  }
  _createClass(Map, [{
    key: "createMapLink",
    value: function createMapLink() {
      var _this$props = this.props,
        businessName = _this$props.businessName,
        address = _this$props.address;
      var query = generateGoogleSearchQuery(businessName, address);
      var embedBase = "https://www.google.com/maps/embed/v1/place?key=".concat(process.env.GOOGLE_MAPS_API_KEY, "&q=");
      return "".concat(embedBase).concat(query);
    }
  }, {
    key: "render",
    value: function render() {
      var isSSR = isServerSideRendering();
      return /*#__PURE__*/React.createElement(React.Fragment, null, !isSSR && /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(Placeholder, {
          className: "map"
        }, /*#__PURE__*/React.createElement(Placeholder.Image, null))
      }, /*#__PURE__*/React.createElement(LazyEmbed, {
        url: this.createMapLink(),
        active: true,
        className: "map",
        iframe: {
          loading: 'lazy'
        }
      })));
    }
  }]);
  return Map;
}(React.Component);
export { Map as default };
Map.defaultProps = {
  businessName: ''
};